<template>
	<AjaxForm
		:method="formMethod"
		:action='formAction'
		:params="modelInfoReal"
		:successCallback="successCallback2">

		<slot :modelInfo="modelInfoReal"></slot>

		<b-overlay :show="loading" no-wrap></b-overlay>
	</AjaxForm>
</template>

<script>
import AjaxForm from './AjaxForm.vue'
import api from '../../api.js'

export default {
	props: {
		modelId: {
			type : Number,
			required: false,
			default:-1
		},
		resource: {
			type : String,
			required: true
		},
		modelInfo: {
			type : Object,
			required: true
		},
		successCallback: {
			type : Function,
			required: false,
			default: () => {}
		}
	},
	components: { AjaxForm },
	data(){
		return {
			loading:false,
			modelIdReal:-1,
			modelInfoReal:{
			},
		}
	},
	computed: {
		formAction(){
			return this.modelId > 0 ? `/${this.resource}/${this.modelId}` : `/${this.resource}`
		},
		formMethod(){
			return this.modelId > 0 ? 'put' : 'post'
		}
	},
	methods:{
		successCallback2(event){
			if(this.modelId <= 0) {
				this.modelInfoReal = {...this.modelInfo}
			}
			this.$root.$emit('bv::refresh::table', `${this.resource}-index-list`)
			this.successCallback(event);
		},
		fetchModel(modelId){
			if(modelId > 0){
				this.$emit('fetch')
				this.loading = true
				api(this).get(`/${this.resource}/`+this.modelId).then((res) => {
					this.modelInfoReal = {...res.data}
					this.loading = false
					this.$emit('update:params', this.modelInfoReal)
				}).catch(this.$root.handleRequestError);
			}else{
				this.modelInfoReal = {...this.modelInfo}
			}
		},
		setAttr(attr,value){
			this.modelInfoReal[attr] = value
		}
	},
	mounted(){
		this.fetchModel(this.modelId)
		// if(this.modelId <= 0){
			// this.modelInfoReal = {...this.modelInfo}
			// this.loading = false
		// }
	},
	updated(){
		// this.modelIdReal = this.modelId
	},
	watch:{
		modelId: function(val) {
			this.fetchModel(val)
		}
	}
}
</script>

<style>

</style>
